import styles from './styles.module.scss';
import {DialogRoot, DialogTrigger} from '@chakra-ui/react';
import classNames from 'classnames';
import Dialog from 'components/dialog';
import ForgotForm from './forgot-form';
import React, {useState} from 'react';
import useWindowSize from 'hooks/useWindowSize';
import {BREAKPOINTS} from '../../../constants';

const Forgot = () => {
  const [open, setOpen] = useState(false);
  const {width} = useWindowSize();
  return (
    <DialogRoot
      scrollBehavior="inside"
      size={width < BREAKPOINTS.MD ? 'full' : 'lg'}
      onOpenChange={() => {
        setOpen(!open);
      }}
      placement="center"
      className={styles.container}
    >
      <div className={styles.ml}>
        <DialogTrigger>
          <div className={classNames(styles.forgot)}>Forgot your password?</div>
        </DialogTrigger>
      </div>

      <Dialog isOpen={open} containerClassNames={styles.container}>
        <ForgotForm />
      </Dialog>
    </DialogRoot>
  );
};

export default Forgot;
